import "utility/validation";
import * as yup from "yup";

export default yup.object().shape({
  name: yup.string().required("newOrder.forms.bookingForm.customerForm.fullnameRequiredError"),
  phone: yup.string().required("common.forms.phoneRequiredError").phone("common.forms.phoneInvalidError"),
  email: yup.string().required("common.forms.emailRequiredError"),
  pricing: yup.object().shape({
    paymentType: yup.string(),
  }),
  card: yup
    .object()
    .shape({ defaultCard: yup.mixed().nullable(), cardReady: yup.boolean() })
    .card("Card validation failed"),
});
